module.exports = __webpack_public_path__ + "img/logo.7d41a7ec.png";